import TransportSyncFeedbackDialog from "./components/calendar/TransportSyncFeedback";
import Login from "./components/root/Login";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import RootNav from "./components/root/RootNav";
import { useGlobalStore, usePersistantStore } from "./stores/global";
import SetPassword from "./shared/forms/SetPassword";
import Project from "./components/planning/Project";
import TestList from "./components/TestList";
import MainCalendar from "./components/calendar/MainCalendar";
import Settings from "./components/settings/Settings";
import SettingsList from "./components/settings/SettingsList";
import EditUsers from "./shared/forms/EditUsers";
import RoleAssignmentAssistant from "./components/users/RoleAssignmentAssistant";
import SettingsEditor from "./components/settings/SettingsEditor";
import Disposition from "./components/calendar/Disposition";
import MixingPlants from "./components/calendar/MixingPlants";
import KGP from "./components/calendar/KGP";
import JonasCalendar from "./components/calendar2/JonasCalendar";
import MachineTransportWrap from "./components/machinetransport/MachineTransportWrap";
import BaumobilCheck from "./components/baumobil/BaumobilCheck";
import FuelReport from "./components/fuel/FuelReport";
import LivemapContainer from "./components/map/LiveMap";
import { useEffect, useState } from "react";
import { resetTransportOrderStatuses } from "./stores/transportOrderStatus";
import Stoffstrom from "./components/stoffstrom/Stoffstrom";
import Service from "./components/service/Service";
import Startpage from "./components/startpage/Startpage";

const queryClient = new QueryClient();

const SetPasswordWrapper = () => {
  const [forced, setForced] = useState(false);
  const setPageTitle = useGlobalStore((state) => state.setPageTitle);
  const setPasswordChangeNecessary = useGlobalStore((state) => state.setPasswordChangeNecessary);
  const passwordChangeNecessary = useGlobalStore((state) => state.passwordChangeNecessary);
  useEffect(() => {
    setForced(passwordChangeNecessary);
    setPasswordChangeNecessary(false);
  }, []);
  return <SetPassword forced={forced} setPageTitle={setPageTitle} />;
};

const EditUsersWrapper = () => {
  const setPageTitle = useGlobalStore((state) => state.setPageTitle);
  return <EditUsers hasFirstName setPageTitle={setPageTitle} allowEmptyRights renderRoleAssistant={(props) => <RoleAssignmentAssistant {...props} />} />;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootNav />,
    children: [
      {
        index: true,
        element: <Startpage />,
      },
      {
        path: "project/:id",
        element: <Project />,
      },
      {
        path: "password",
        element: <SetPasswordWrapper />,
      },
      {
        path: "calendar",
        element: <MainCalendar />,
      },
      {
        path: "map",
        element: <LivemapContainer />,
      },
      {
        path: "calendar2",
        element: <JonasCalendar />,
      },
      {
        path: "disposition",
        element: <Disposition />,
      },
      {
        path: "service",
        element: <Service />,
      },
      {
        path: "kgp",
        element: <KGP />,
      },
      {
        path: "machinetransport",
        element: <MachineTransportWrap />,
      },
      {
        path: "plants",
        element: <MixingPlants />,
      },
      {
        path: "stoffstrom",
        element: <Stoffstrom />,
      },
      {
        path: "tankungen",
        element: <FuelReport />,
      },
      {
        path: "baumobil",
        element: <BaumobilCheck />,
      },
      {
        path: "settings",
        element: <Settings />,
        children: [
          {
            index: true,
            element: <Navigate replace to="/settings/resourceTag" />,
          },
          {
            path: "user/:rawId",
            element: <EditUsersWrapper />,
          },
          {
            path: ":type/:rawId",
            element: <SettingsEditor />,
          },
          {
            path: ":type",
            element: <SettingsList />,
          },
        ],
      },
    ],
  },
]);

const App = () => {
  const authenticated = usePersistantStore((state) => state.authenticated);
  const userId = usePersistantStore((state) => state.userId);
  useEffect(() => resetTransportOrderStatuses(), [authenticated, userId]);

  return <QueryClientProvider client={queryClient}>{authenticated ? <><RouterProvider router={router} /><TransportSyncFeedbackDialog /></> : <Login />}</QueryClientProvider>;
};

export default App;
